class Explode {
  constructor(ctx, x, y) {
    this.ctx = ctx;

    this.x = x;
    this.y = y;

    this.spriteWidth = 100;
    this.spriteHeight = 179;

    this.width = this.spriteWidth * 1.5;
    this.height = this.spriteHeight * 1.5;

    this.image = new Image();
    this.image.src = "https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/boom.webp";
    
    this.frame = 0;
    this.timer = 0;
  }

  update() {
    this.timer++;

    if (this.timer % 10 === 0) this.frame++;
  }

  draw() {
    this.ctx.drawImage(
      this.image,
      this.spriteWidth * this.frame,
      0,
      this.spriteWidth,
      this.spriteHeight,
      this.x,
      this.y,
      this.width,
      this.height
    );
  }
}

export { Explode };